import { render, staticRenderFns } from "./UpdateICDRanap.vue?vue&type=template&id=85c8f36e&scoped=true"
import script from "./UpdateICDRanap.vue?vue&type=script&lang=js"
export * from "./UpdateICDRanap.vue?vue&type=script&lang=js"
import style0 from "./UpdateICDRanap.vue?vue&type=style&index=0&id=85c8f36e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c8f36e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85c8f36e')) {
      api.createRecord('85c8f36e', component.options)
    } else {
      api.reload('85c8f36e', component.options)
    }
    module.hot.accept("./UpdateICDRanap.vue?vue&type=template&id=85c8f36e&scoped=true", function () {
      api.rerender('85c8f36e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/pasienicd/UpdateICDRanap.vue"
export default component.exports